import React from 'react';
import styled, { css } from 'styled-components';

import { Box, Flex, Text, BetaBadge } from 'Components/Base';
import { LEARNING_MODE } from 'Context/ClassroomContext';

import LinearProgressWithLabel from './LinearProgressWithLabel';
import LearningModeOptionSelector from './LearningModeOptionSelector';
import DisclaimerPanel from './DisclaimerPanel';

const Divider = () => <Box style={{ borderTop: '1px solid #E5E5E5' }} />;

const PANEL_TITLE = 'โหมดการเรียน';
const PROGRESSION_TEXT = 'ความคืบหน้า';

const PanelTitle = styled((props) => (
  <Text fontWeight={'semibold'} textStyle={'body1'} {...props} />
))`
  padding-left: ${({ theme }) => `${theme.space[2]}px`};
  flex-grow: 1;
`;

const ProgressBox = styled(Flex)`
  ${({ theme }) => css`
    background-color: ${theme.colors.greyscale.grey5};
    padding: ${theme.space[4]}px;
    margin-top: ${theme.space[4]}px;
    align-items: center;
    border-radius: 4px;
    gap: ${theme.space[4]}px;
  `}
`;

const Collapse = styled(({ open, ...props }) => (
  <Box style={{ maxHeight: open ? '300px' : '0' }} {...props} />
))`
  overflow: hidden;
  transition: max-height 150ms ease-in-out;
`;

const LearningModePanel = ({
  learningModeDetailOptions,
  learningModeLearningProgressPercentage,
  currentLearningMode,
  setCurrentLearningMode,
}) => {
  const handleLearningModeSelection = (selectedLearningModeId) => {
    setCurrentLearningMode(selectedLearningModeId);
  };

  const isEnableLearningMode = currentLearningMode !== LEARNING_MODE.DEFAULT;

  return (
    <>
      <Divider />
      <Flex flexDirection="column" p={4}>
        <Flex alignItems="center">
          <PanelTitle>{PANEL_TITLE}</PanelTitle>
        </Flex>
        <Flex py={4} pl={2}>
          <LearningModeOptionSelector
            learningModeDetailOptions={learningModeDetailOptions}
            handleLearningModeSelection={handleLearningModeSelection}
            currentLearningMode={currentLearningMode}
          />
        </Flex>
        <Collapse open={isEnableLearningMode}>
          <ProgressBox>
            <Text fontWeight={'normal'} textStyle={'caption'}>
              {PROGRESSION_TEXT}
            </Text>
            <LinearProgressWithLabel value={learningModeLearningProgressPercentage} />
          </ProgressBox>
          <DisclaimerPanel mt={3} />
        </Collapse>
      </Flex>
      <Divider />
    </>
  );
};

export default LearningModePanel;
